import { Container, Title, Text, Button, Flex, rem } from '@mantine/core';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
import { getLinearGradient } from '../../../mantineTheme';

export function FinalCTA() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const variants = {
    hidden: { scale: 0.5, opacity: 0 },
    visible: { scale: 1, opacity: 1, transition: { duration: 0.7, ease: [0.175, 0.885, 0.32, 1.275] } },
  };

  return (
    <Container size="sm" ref={ref}>
      <motion.div
        variants={variants}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        style={{ textAlign: 'center' }}
      >
        <Title order={2} style={{ fontSize: rem(40), marginBottom: rem(20) }}>
          Ready to Elevate Your Influence?
        </Title>
        <Text size="lg" c="dimmed" mx="auto" style={{ maxWidth: 500, marginBottom: rem(30) }}>
          Join Collabish today and start building meaningful partnerships that drive results.
        </Text>
        <Flex gap="md" justify="center">
            <Button 
                component={Link} 
                to="/creator-ai-assistant"
                size="lg" 
                radius="xl" 
                style={{ background: getLinearGradient('primary') }}
            >
                Get Started as a Creator
            </Button>
            <Button 
                component={Link} 
                to="/brand-dashboard"
                size="lg" 
                radius="xl" 
                variant='outline' 
                color='primary'
            >
                Get Started as a Brand
            </Button>
        </Flex>
      </motion.div>
    </Container>
  );
}
